enum OFFER_TEMPLATES {
  custom = 'CUSTOM',
  checkIn = 'EARLY_CHECK_IN',
  checkOut = 'LATE_CHECK_OUT',
  housekeeping = 'EXTRA_HOUSEKEEPING',
  airportTransfer = 'TRANSPORT_FROM_AIRPORT',
  cityTour = 'CITY_TOUR',
  spaTicket = 'SPA_TICKET',
}

enum OFFER_PRICE_TYPES {
  single = 'SINGLE_PRICE',
  multiple = 'MULTIPLE_PRICE',
}

enum OFFER_PRICES_FIELD {
  price = 'price',
  unit = 'unit_type',
  name = 'name',
  day = 'day',
}

enum UNIT_PRICE_TYPES {
  unit = 'PER_UNIT',
  day = 'PER_DAY',
  person = 'PER_PERSON',
  group = 'PER_GROUP',
}

enum DEAL_STATUSES {
  pre_requested = 'PRE_REQUESTED',
  requested = 'REQUESTED',
  approved = 'APPROVED',
  rejected = 'REJECTED',
  paid = 'PAID',
}

enum OFFER_CATEGORIES {
  checkInCheckOut = 'CHECK_IN_CHECK_OUT',
  checkIn = 'EARLY_CHECK_IN',
  checkOut = 'LATE_CHECK_OUT',
  transportation = 'TRANSPORTATION',
  fAndB = 'F_AND_B',
  seasonal = 'SEASONAL',
  family = 'FAMILY',
  romantic = 'ROMANTIC',
  healthAndSpa = 'HEALTH_AND_SPA',
  artAndCulture = 'ART_AND_CULTURE',
  activities = 'ACTIVITIES',
  services = 'SERVICES',
  propertyProtection = 'PROPERTY_PROTECTION',
  others = 'OTHERS',

  essentials = 'ESSENTIALS',
  luggageServices = 'LUGGAGE_SERVICES',
  nature = 'NATURE',
  petFriendly = 'PET_FRIENDLY',
  freeOffers = 'FREE_OFFERS',
}

enum OFFER_CONFIRMATION_TYPES {
  auto = 'AUTO',
  manual = 'MANUAL',
}

enum OFFER_STATUSES {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
}

export {
  OFFER_STATUSES,
  OFFER_TEMPLATES,
  OFFER_PRICE_TYPES,
  OFFER_PRICES_FIELD,
  UNIT_PRICE_TYPES,
  DEAL_STATUSES,
  OFFER_CATEGORIES,
  OFFER_CONFIRMATION_TYPES,
};
